module.exports = __webpack_public_path__ + "static/media/slack.48a3232b.svg";